import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import * as styles from './index.module.css'
import { GradientBorder } from '../commons'
import Button from '../Button/'
import Link from '../Link'

const ConditionalLink = ({ to, children }) => {
  if (!to) {
    return <div>{children}</div>
  }

  return <Link to={to}>{children}</Link>
}

const ProductsShowCase = ({ title, subtitle, components }) => {
  const isMobile = typeof window !== `undefined` && window.innerWidth <= 1024
  const defaultTitleColor = '#000'
  const defaultLabelColor = '#000'
  return (
    <div className={styles.backdrop}>
      <div className="wrapper">
        <div className={styles.container}>
          <div className={styles.products}>
            {components.map((product, idx) => (
              <div className={styles.product} key={idx}>
                <div className={styles.productContent}>
                  <ConditionalLink to={product.ctaUrl}>
                    <GatsbyImage
                      image={product.gatsbyImageData}
                      className={styles.productShot}
                      alt={product?.image?.description}
                    />
                    <h2
                      className={styles.productTitle}
                      style={{
                        color:
                          product.title.split(';').length > 1
                            ? product.title.split(';')[1]
                            : defaultTitleColor,
                      }}
                    >
                      {product.title.split(';')[0]}
                    </h2>
                  </ConditionalLink>

                  <h4
                    className={styles.label}
                    style={{
                      color:
                        product.subtitle.subtitle.split('\n')[0].split(';')
                          .length > 1
                          ? product.subtitle.subtitle
                              .split('\n')[0]
                              .split(';')[1]
                          : defaultLabelColor,
                    }}
                  >
                    {product.subtitle.subtitle.split('\n')[0].split(';')[0]}
                  </h4>
                  <div className={styles.priceText}>
                    {product.subtitle.subtitle.split('\n')[1]}
                  </div>
                  {product.ctaUrl && product.ctaText && (
                    <Link
                      to={product.ctaUrl}
                      children={
                        <Button
                          className={styles.joinUsButton}
                          style={{
                            width: isMobile ? '100%' : '191px',
                            minWidth: isMobile ? '100%' : '191px',
                          }}
                        >
                          {product.ctaText}
                        </Button>
                      }
                    ></Link>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProductsShowCase
